<template>
  <div>
    <h3>Current Sharedo Instance</h3>
    <div class="sharedo-instance">
      <div class="url">
        {{ sharedoInstance }}
      </div>
      <div class="disconnect">
        <router-link class="btn btn-primary" to="reset">Disconnect</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import sharedoSettings from "@/services/sharedo/sharedoSettingsService";

export default {
  computed: {
    sharedoInstance: function() {
      const settings = sharedoSettings.get();
      return settings.sharedoApi;
    },
  },
};
</script>
<style lang="scss" scoped>
h5 {
  font-weight: bold;
}
.sharedo-instance {
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > .url {
    display: inline-block;
    flex-grow: 1;
    font-size: 0.8rem;
  }
}
</style>
